export default {
  arribo: 'Arribo',
  global: {
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    logout: 'Log out',
    from: 'from',
    month: 'month',
    finish: 'Finish',
    findYourRecommendation: 'Find your recommendation',
  },
  language: {
    es: 'Spanish',
    en: 'English',
  },
  validations: {
    minLength: 'Cannot be less than {min} characters',
    invalidFileSize: 'The file size should not be larger than {size}',
    uppercase: '1 uppercase required',
    lowercase: '1 lowercase required',
    number: '1 number required',
    specialChar: '1 special character required',
  },
  actions: {
    logoutText: 'Are you sure? You’re about to log out',
    yesLogout: 'Yes, log out',
    createAccount: 'Create account',
    changeEmail: 'Change email',
    changePassword: 'Change password',
    recoveryPassword: 'Recover password',
    discard: 'Discard',
    saveEmail: 'Save email',
    resendCode: 'Resend code',
    confirm: 'Confirm',
    enterCode: 'Enter code',
    cancel: 'Cancel',
    sendEmail: 'Send email',
    saveChanges: 'Save changes',
    upload: 'Upload',
    save: 'Save',
    recovery: 'Recovery',
    complete: 'Complete',
    uploading: 'Uploading ...',
    showAll: 'Show all',
    hideAll: 'Hide all',
    signNow: 'Sign now',
    add: 'Add',
    viewFile: 'View file',
    delete: 'Delete',
  },
  splash: {
    claim: 'Claim',
  },
  welcome: {
    createAccount: 'Create account',
    continueGuest: 'Continue as a guest',
    haveAnAccount: 'I already have an account',
    goToWelcome: 'Go to Home',
    inAllianceWith: 'In alliance with ',
  },
  login: {
    title: 'Log into your account',
    passwordRecovery: 'Password recovery',
    notAccount: 'I don’t have an account yet',
    enterNow: 'Enter now',
    invalidMessage: 'Invalid password or email Login',
    labels: {
      email: 'Email',
      password: 'Password',
    },
    placeholders: {
      password: 'Password',
    },
    successMessage: 'Login successful',
  },
  recovery: {
    title: 'Recover your password',
  },
  signUp: {
    emailTitle: 'Create your account',
    emailDescription:
      'Let’s get you all set up. First, confirm your email address where you were notified.',
    passwordTitle: 'Create your password',
    passwordDescription: 'Password requires at least: ',
    passwordDescriptionLeast: {
      minCharacters: '8 characters minimum',
      uppercase: '1 uppercase',
      lowercase: '1 lowercase',
      number: '1 number',
      special: '1 special character',
    },
    placeholders: {
      email: 'Email',
      password: 'Password',
      acceptTerms: 'I accept the',
      terms: 'terms and conditions.',
    },
  },
  verifyAccount: {
    title: 'Checking ...',
  },
  onBoarding: {
    title: 'Make Arribo uniquely yours',
    description:
      'Arribo works best when it’s tailored to your preferences. Take 2 minutes and enjoy a more relevant experience.',
    personalizeExperience: 'Personalize experience',
    skipPersonalization: 'Skip personalization',
  },
  rules: {
    required: 'Required field',
    email: 'Please enter a valid email address.',
    number: 'Please enter a valid number.',
    phoneInvalid: 'Phone number is not valid.',
    phoneMin: 'Phone number must be at least 6 characters',
    phoneMax: 'Phone number must be at most 10 characters',
    decimal: 'Please enter a valid decimal number.',
    max: 'Maximum length is {max} characters.',
    min: 'Minimum length is {min} characters.',
    password:
      'Your password must contain a minimum of 8 characters, one capital letter and one special character',
    passwordMismatch: 'Passwords do not match',
    names: 'Invalid name',
    documentId: 'Invalid document ID',
  },
  personalize: {
    cityTitle: 'Where are you traveling?',
    cityDescription: 'We’ll prepare a city guide and curate relevant suggestions just for you.',
    infoTitle: 'Tell us about you',
    infoDescription: 'We’ll adapt our preparation checklist to ensure its useful to you.',
    datesTitle: 'When will you travel?',
    datesDescription: 'We’ll only show available accommodations. You can change it later.',
    purposeTitle: 'Why are you travelling?',
    purposeDescription:
      'We’ll cater the experience to your travel purpose to keep things relevant.',
    labels: {
      city: 'City',
      name: 'Name',
      lastname: 'Last name',
      location: 'Origin Location (City, country)',
      arrival: 'Arrival',
      departure: 'Departure',
      birthdate: 'Birthdate',
      purpose: 'Purpose',
    },
    placeholders: {
      city: 'City',
      name: 'Name',
      lastname: 'Last name',
      location: 'Location',
      arrival: 'Arrival',
      departure: 'Departure',
      birthdate: 'Birthdate',
      purpose: {
        options: {
          student: "I'm a student",
          work: 'I travel for work',
          Leisure: 'Leisure',
          other: 'Other',
        },
      },
    },
  },
  announcement: {
    payment: {
      monthly: 'Monthly payment',
      fortnightly: 'Fortnightly payment',
      daily: 'Daily payment',
    },
    minPeriod: 'Minimum number of days allowed to booking',
    days: 'Days',
    monthly: 'Monthly',
    fortnightly: 'Fortnightly',
    daily: 'Daily',
    numBath: 'Bathrooms',
    bathroom: 'Bathroom',
    policy: {
      title: 'Cancellation Policy',
      strict: {
        1: 'No refund',
      },
      flexible: {
        1: 'Full refund up to 30 days before check-in. Partial refund (50% of the booking cost) between 7 and 30 days before check-in. Deposit, reservation, owner fee costs are non-refundable.',
      },
    },
    bedroom: 'Bedroom',
    bedrooms: 'Bedrooms',
    photos: 'Photos',
    videos: 'Videos',
    virtual: 'virtual tour',
    map: 'Map',
    location: 'Location',
    thisIs: 'Ideal place for',
    registry: 'Registry number',
    roomIn: 'Room in a property',
    kitchenIncluded: 'Kitchen',
    yourOwnKitchen: 'The property has a kitchen tailored to your needs.',
    yourOwn: 'Your own room in accommodation, plus access to shared spaces.',
    sharedSpaces: 'Shared spaces',
    youWill: 'You will share some areas of the accommodation.',
    sharedBathroom: 'Shared bathroom',
    youWillShare: 'You will share the bathroom with other people.',
    youWillStay: 'You will stay here',
    services: 'Services and expenses',
    viewAll: 'View all',
    cancellation: 'Cancellation Pollicies',
    totalArea: 'Total area',
    maxCap: 'Maximum capacity',
    people: 'people',
    rentalConditions: 'Rental conditions',
    contractModel: 'Contract model',
    season: 'Season',
    terms: 'Terms of Payment and contract model',
    bookNow: 'Book now',
    thisPlace: 'This place offers',
    generalInformation: 'General Information',
    features: 'Features',
    furniture: 'Furniture',
    furnitures: 'Furnitures',
    createAccount: 'Create account',
    unlockDetails: 'Unlock details and booking',
    orLogin: 'or login',
  },
  search: {
    loadMoreResults: 'Load more results',
    results: 'results',
    cantFind: 'Can’t find anything you like?',
    changeYour: 'Change your preferences',
    discover: 'Discover where to stay',
    personalize: 'Personalize recommendations',
    discoverDescription:
      'Wherever you go, we can help you find a place to stay that fits your needs.',
    showRec: 'Show recommendations',
    clearFilters: 'Clear filters',
    applyPreferences: 'Apply preferences',
    city: 'City',
    dateRange: 'Date range',
    arrival: 'Arrival',
    departure: 'Departure',
    accomType: 'Accomodation type',
    priceRange: 'Price range',
    minPrice: 'Min. Price',
    maxPrice: 'Max. Price',
  },
  profile: {
    documentTitle: 'Documents',
    title: 'Profile',
    showProfile: 'Complete your profile',
    joinDateWithYear: '{years} years and {days} days in Lodgerin',
    joinDate: '{days} days in Lodgerin',
    myProfileTitle: 'Personal data',
    editTitle: 'Edit profile',
    editDescription: 'General information',
    myAccountTitle: 'My account',
    myAccountDescription: 'Here you can manage your account data whenever you need it.',
    contactData: 'Contact data',
    moreAboutMe: 'More about me',
    createdOn: 'Created on',
    latestUpdate: 'Last update',
    profileUpdatedSuccessfully: 'Profile updated successfully',
    myDocumentTitle: 'Documents',
    myDocumentDetailTitle: '{type} detail',
    personalData: 'Personal data',
    myAccount: 'My account',
    documents: 'ID Documents',
    settings: 'Settings',
    changePhotoProfile: 'Change profile picture',
    notPersonalData: 'You have not yet entered personal data',
    areaCode: 'Area Code',
    enterCountryName: 'Enter country name',
    nationalityTitle: 'Nationality',
    nationalitySearch: 'Search Nationality',
    labels: {
      name: 'Name',
      lastName: 'Last name',
      gender: 'Gender',
      nationality: 'Nationality',
      code: 'Code',
      phoneNumber: 'Phone number',
      documentType: 'Document type',
      documentId: 'Personal Document number',
      id: 'ID',
      passport: 'Passport',
      nif: 'NIF',
      nie: 'NIE',
      taxId: 'Business document number',
      birthdate: 'Birthdate',
      age: 'Age',
      origin: 'Origin',
      numberId: 'ID number',
      renewal: 'Select issue/renewal date',
      expiration: 'select expiration date',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      language: 'Language',
    },
    placeholders: {
      name: 'Name',
      lastName: 'Last name',
      numberId: 'Document number',
      renewal: 'Select issue/renewal date',
      expiration: 'select expiration date',
    },
    email: {
      title: 'Email',
      description:
        'Please enter the new email address you wish to change to. Make sure you provide a valid address that you have access to.',
      descriptionCode:
        'We have received your request to change the email address associated with your account. Please check your inbox and enter the verification code we sent you. ',
      changeEmail: 'Change email',
      emailPlaceholder: 'New email',
      enterCode: 'Enter code',
      codePlaceholder: 'Enter code',
      emailChangedSuccessfully: 'Email changed successfully',
    },
    password: {
      title: 'Password',
      description: 'Change your password.',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      passwordChangedSuccessfully: 'Password changed successfully',
    },
    recovery: {
      description: 'Enter your email address to change your password',
      emailPlaceholder: 'Email',
    },
    photo: {
      photoChangedSuccessfully: 'Photo changed successfully',
    },
    document: {
      detail: 'Detail',
      edit: 'Edit',
      download: 'Download',
      rentalContract: 'Rental Contract',
      documentToSign: 'Document to sign',
      downloadContractSigned: 'Download Contract Signed',
      signNow: 'Sign now',
      signNowDescription:
        'Your rental contract is ready to sign! Make sure you sign it before check-in in to accommodation.',
      pendingSignByOwner: 'Owner sign pending',
      Passport: 'Passport',
      'ID Document': 'Personal Document identity',
      'Select Issue/renewal date': 'Expiration date',
      'Rental Contract': 'Rental Contract',
      'Contrato de Renta': 'Rental Contract',
    },
    setting: {
      title: 'Language',
      description: 'Please select the language you prefer for using the Lodgerin platform.',
      languageUpdatedSuccessfully: 'Language changed successfully',
      notifications: 'Notifications',
      notificationsDescription: 'Receive app notifications ',
    },
    account: {
      requestInProcess: 'Request in process',
      deleteAccount: 'Delete account',
      description: 'Request the deletion of the account and all its data',
      request: 'Request deletion',
      requestDescription:
        'Upon processing your request, your personal information, including photos and chats, will be permanently removed from our platform.',
      dateProgramed:
        'Your account deletion request is in progress. The scheduled date for deletion is',
      cancel:
        '. You can cancel this request at any time before that date by logging back into your account. Until then, your information will be kept secure.',
    },
  },
  files: {
    passport: 'Passport',
    'id document': 'Document ID',
    upload: 'Upload {title}',
    'Add document image': 'Add document image',
    'Add images': 'Add image',
    'Browse file': 'Browse file {type}',
    browseImage: 'Browse {type}',
    gallery: 'Upload an image from your gallery',
    photo: 'Take a picture',
    fileDescription:
      'The image format must be JPEG, JPG, PNG or PDF. And that it should not weigh more than 5MB.',
    expires: {
      expiresMoreTwelveMonths: 'Expires in more than 12 months',
      expiresMoreSixMonths: 'Expires in 6 to 12 months',
      expiresMoreThreeMonths: 'Expires in 3 to 6 months',
      expiresLessThreeMonths: 'Expires in less than 3 months',
      expired: 'Expired file',
      numberId: 'ID number',
      renewal: 'Issue/renewal date',
      expiration: 'Expiration date',
      lastUpdated: 'Last updated',
      expirationStatus: 'Expiration status',
    },
    signContractManualDescription:
      'Download, print and sign the rent contract. Then scan the file and upload it as PDF, make sure the file weight is less than 5MB.',
    browseFile: 'Browse file',
    uploadDocument: 'Upload document',
    replaceNow: 'Replace now',
    status: {
      verificationStatus: 'Verification status',
      pending: 'Pending',
      rejected: 'Rejected',
      signedByOwner: 'Signed by owner',
      verified: 'Verified',
      pendingAcceptanceOrReview: 'Pending acceptance or review',
      not_validated: 'Not validated',
      validated: 'Validated',
    },
  },
  bookingDetails: {
    weDidntFind: "Oops we didn't find any accommodation available",
    makeChanges: 'Make changes to your reservation to find the ideal accommodation for you',
    myBooking: 'My booking',
    title: 'Booking Details',
    myPage: 'My place',
    hoursRemain: 'The owner will review your request and respond within {hours}hs maximum',
    datesOf: 'Dates of stay',
    rejectingReason: 'Rejecting reason: {reason}',
    ohNo: 'Oh no! Your booking request was rejected',
    someSuggestions:
      'However, we’ve prepared some suggestions that might match with your last search',
    pendingPayment: 'You have an invoice pending payment. Remember to pay within the next 48 hours',
    notBooking: 'You don’t have any reservation yet',
    notBookingDescription:
      'Wherever you go, we can help you find a place to stay that fits your needs.',
    myStay: 'My Stay',
    nextAccommodation: 'Your next accommodation',
    cancelledAccommodation: 'Your reservation has been cancelled',
    showBookingDetails: 'Show booking details',
    previousAccommodation: 'Your previous accommodation',
    invoiceMessage1: 'Your reservation has been accepted.',
    invoiceMessageBold: "You have 48 hours to pay the first month's rent or the deposit, ",
    invoiceMessage2: 'as stipulated in your contract. See your profile for details.',
  },
  invoices: {
    download: 'Download',
    payNow: 'Pay now',
    paymentsAnd: 'Payments and bills',
    invoice: 'invoice',
    billingDetails: 'Billing details',
    name: 'Name',
    billingAddress: 'Billing address',
    email: 'Email',
    issueDate: 'Issue date',
    paidOn: 'Paid on',
    paymentDeadline: 'Payment deadline',
    status: 'Status',
    invoiceList: 'Invoice list',
    subtotal: 'Subtotal',
    total: 'Total',
    to: 'To',
    from: 'From',
  },
  status: {
    pending: 'Pending',
    accepted: 'Accepted',
    paid: 'Paid',
    canceled: 'Cancelled',
    sent: 'Pending',
  },
  tabs: {
    guides: 'Guides',
    myStay: 'My Stay',
    explore: 'Explore',
    support: 'Support',
    perks: 'Perks'
  },
  documents: {
    addId: 'Add ID document',
    selectType: 'Select a type of ID document to upload',
    addIdOn: 'Add ID',
    idDocument: 'ID document',
    description:
      'Select an uploaded ID document or add a new one. Improve your profile by generating trust in accommodation owners',
  },
  booking: {
    bookingData: 'Booking data',
    host: 'Host',
    rent: 'Rent',
    days: 'Days',
    people: 'People',
    billing: {
      commercial: 'Commercial name',
      title: 'Billing data',
      billingSubject: {
        people: 'Relocated',
        entity: 'Organization',
      },
      description:
        'Select the billing subject. We’ll use this information for your future invoices',
      complete: 'Complete with your profile data',
      name: 'Name',
      idType: 'ID Type',
      documentId: 'ID number',
      email: 'Email',
    },
    editDates: {
      title: 'Edit reservation dates',
      btn: 'Save date changes',
      description:
        'By edit the reservation dates we must verify that the accommodation will be available in the new period of stay. If there is no availability, you’ll have to select another accommodation.',
    },
    verify: {
      title: 'Verify your booking data',
      description:
        'Select the services you want to add to your reservation. These values will be added to the agreed rental price',
      costSummary: 'Cost sumary',
      upfront: 'Upfront costs',
      reservationValue: 'Reservation',
      deposit: 'Deposit',
      fixed: 'Fixed costs',
      rent: 'Rent price',
      taxes: 'Taxes',
      confirm: 'Confirm booking',
    },
    services: 'Additional services',
    servicesDescription:
      'Select the services you want to add to your reservation. These values will be added to the agreed rental price',
    documents: {
      title: 'Documents',
      description: 'Complete and review your personal information',
    },
    botonChat: {
      title: 'Chat with host', //Agregamos título botonChat
    },
  },
  gender: {
    female: 'Female',
    Male: 'Male',
  },
  cancelledReasonsItems: {
    temp: 'Temporarily unavailable due to renovation',
    prev: "Previous tenant's reservation extension",
    ten: "The tenant didn't fill the requirements",
    rate: 'The rate doesn’t meet the agreed conditions',
    stay: 'Staying period less than minimum established',
    acco: 'The accommodation is reserved in that period of time',
    dep: 'The deposit is not enough or was not been found',
    meet: 'The tenant has not met the deposit or bond requirements stipulated to confirm the reservation',
    unna: 'Unacceptable cancellation policies',
    canc: "The tenant’s cancellation policies doesn't match with the accommodation agreement",
    owner: 'The owner policies has changed',
    book: 'The booking terms updates don’t match the tenant request',
    error: 'Error on the property availability',
    prop: 'Property availability synchronization failed',
    noReason: 'No reason provided',
  },
  property: {
    titleDetail: 'Property detail',
    availableAccommodations: 'Rooms available in this accommodation',
  },
  filters: {
    location: 'Location',
    filters: 'Filters',
    accommodations: 'Accommodations',
    allProperties: 'All',
  },
  'check-in': {
    welcome: 'Welcome',
    description:
      'We’re delighted to host your staying. We’ll check your accommodation features in two main steps:',
    stepOne: '1. General accommodation aspects',
    stepTwo: '2.Review of property spaces',
    startCheck: 'Start Check-in',
    generalAspects: 'General aspects',
    spacesReview: 'Spaces review',
    youHaveFinished: 'You have finished the general accommodations aspects!',
    continueSpaces: 'Let’s continue with the review from each space from the property',
    startSpaces: 'Start spaces rewiew',
    suggestions: 'Do you have a suggestions for the landlord?',
    suggestionsText: 'Please let us know how we can improve your stay by leaving a message',
    writeComment: 'Write a comment',
    skipThis: 'Skip this step',
    yes: 'Yes',
    goToArribo: 'Go to Arribo App',
    youHaveFinishedCheck: 'You have finished your check-in!',
    finishDescription: 'Return to your App and enjoy your stay',
    report: 'Report incident',
    reportDescription: 'Describe your disagreement and upload images to support your report',
    createReport: 'Create report',
    reportSaved: 'Report saved!',
    card: 'Your check-in process is now available. You could complete it within 48 hours maximum',
    cardBtn: 'Start check-in',
  },
  'check-out': {
    welcome: 'Hi,',
    description:
      'We hope you’re staying had been pleasant. We’ll check your accommodation features in two main steps before your departure:',
    stepOne: '1. General accommodation aspects',
    stepTwo: '2. Review of property spaces',
    startCheck: 'Start Check-out',
    generalAspects: 'General aspects',
    spacesReview: 'Spaces review',
    youHaveFinished: 'You have finished the general accommodations aspects!',
    continueSpaces: 'Let’s continue with the review from each space from the property',
    startSpaces: 'Start spaces rewiew',
    suggestions: 'Do you have a suggestions for the landlord?',
    suggestionsText: 'Please let us know how we can improve your stay by leaving a message',
    writeComment: 'Write a comment',
    skipThis: 'Skip this step',
    yes: 'Yes',
    goToArribo: 'Finish my stay',
    youHaveFinishedCheck: 'You have finished your check-out!',
    finishDescription: 'Your trip has finished now. We hope to help you in your next adventure',
    report: 'Report incident',
    reportDescription: 'Describe your disagreement and upload images to support your report',
    createReport: 'Create report',
    reportSaved: 'Report saved!',
    card: 'Your check-out process is now available',
    cardBtn: 'Start check-out',
  },
  evaluator: {
    description: 'Fill out the form to start check-out as guest',
    firstStep: 'We’ll check the accommodation features in two main steps:',
  },
  post: {
    in: 'in',
    at: 'at',
    guides: 'Guides and articles',
  },
  shepperdTour: {
    modalText: 'In order to book, you need to take a look at the available accommodations',
    finishButton: 'Got it!',
  },
  support: {
    sentByAdmin: 'Sent by Admin',
    online: 'Online',
    notAvailable: 'This chat is not available',
    chat: {
      start: 'Start a conversation',
      writeMessage: 'Write a message',
      searchEmoji: 'Search Emoji',
      skinTone: 'Skin tone',
    },
    owner: {
      titleCard: 'Talk to the owner of your accommodation',
    },
    agent: {
      titleCard: 'Booking assistant',
      descriptionCard: 'Need help? Chat with our support bot for quick answers!',
      titleCard2: 'Generates an incident', //Agregamos título Card2
      descriptionCard2: 'Do you have a problem that needs to be resolved quickly?',//Agregamos descripción Card2
      modalTitle: "Report Incident", //Agregamos título modal
      modalDescription: "Describe your disagreement and upload images to support your the issue", //Agregamos Descripción modal
      addImages: "Add images", //Agregamos boton imagenes
      incidentTitle: "Incident Title", //Agregamos título incidente
      incidentPlaceholder: "Damage to the washing machine", //Agregamos Placeholder
      requiredField: "This field is required", //Agregamos texto requerido
      invalidFormat: "Please write a more descriptive text (min. 6 characters, no strange symbols)", //Agregamos texto validación
      invalidTitle: "Please write a more descriptive title", //Agregamos texto validación título
      invalidMeaning: "Please write a meaningful comment", //Agregamos texto validación comentario
      validationError: "Please complete all required fields correctly", //Agregamos texto error validación modal
      incidentReported: "Your incident has been successfully reported", //Agregamos texto reportado validación modal
      writeComment: "Write a comment", //Agregamos título comentario
      commentPlaceholder: "The washing machine does not work, when you turn it on, an error appears and it does not wash.", //Agregamos Placeholder
      urgency: "Is the incidence of high urgency? (optional)", //Agregamos título urgencia
      urgencyYes: "Yes, it is urgent", //Desplegable opción Sí
      urgencyNo: "No, it can wait", //Desplegable opción No
      noReservation: "You cannot create an incident without an active reservation", // Agregamos mensaje si no hay reserva
      closeButton: "Cancel", //Agregamos Boton de Cancelar
      createReport: "Create report", //Agregamos Boton de Crear reporte
    },
    incident: {
      title: 'Incident history', //Agregamos título
      filter: 'Filters', //Agregamos título botón
      noIncidents: 'No incidents found', //Agregamos no se encontraron incidentes
      invalidDate: 'Date not available', //Agregamos fecha no disponible
      noDescription: 'No description available.', //Agregamos texto sin descripción disponible
      reported: "Reported", //Agregamos estado reportada
      solved: "Solved", //Agregamos estado resuelta
      notAttended: "Not attended", //Agregamos estado no atendida
      referenceCode: 'Accomodation', //Agregamos referencia RU
      descriptionCard: "Need assistance? Chat with us — we're happy to help you!",
    },
    faqs: {
      title: 'FAQs',
      question1: 'How can I update my personal information?',
      answer1:
        'Click on the blue circular icon located in the upper right corner. This will take you to your profile screen, from where you can modify all your personal information, including your password and language.',
      question2: 'Is it mandatory to upload my ID or passport?',
      answer2:
        'Yes, to make a reservation it is mandatory to confirm that your information is correct.',
      question3: 'Can I delete my account?',
      answer3:
        'Yes, by clicking on the blue circular icon located in the upper right corner, select the settings section and at the bottom you can delete your account. To recover it, simply log in again with your data and you will have your Arribo account active again with all the information previously saved.',
      question4: 'How can I see the terms and conditions?',
      answer4:
        'When you register, when you accept the terms and conditions, if you click on the blue link, it will take you to the page where you can read them.',
      question5: 'What is the minimum stay for accommodation?',
      answer5:
        "The minimum stay period for accommodation is decided directly by the owner. When you check the accommodation details in the 'rental conditions', you will be able to see the exact amount of time required. Similarly, in the “notes” of the accommodation you can see additional information about this aspect.",
      question6: 'How do I make a reservation?',
      answer6:
        'Search and select the accommodation that best suits your search with the filters that appear at the top. Once inside, select the room you want to reserve and click on the blue reserve icon that appears at the bottom right. Complete the requested information and the dates of your stay and confirm the reservation. The owner will respond within a maximum period of 48 hours.',
      question7: 'How do I see my pending reservations?',
      answer7:
        "On the main page, at the bottom right, click on the 'my stay' icon and it will take you to the page of your stays.",
      question8:
        'Can I make several reservations even if they are in different accommodation and dates?',
      answer8:
        'No, until you have a confirmed reservation you will not be able to make another new reservation even if it is in a different accommodation and on different dates.',
      question9: 'Can I see the accommodation before moving in?',
      answer9:
        "We do not organize physical or virtual visits. Our reservation process is 100% online, but don't worry, all our properties are verified by our operations department.",
      question10: 'How can I see the amount I am going to pay when my reservation is confirmed?',
      answer10:
        'When making the reservation request, on the second screen, where you enter your reservation details, you will see the summary of the amount to pay and if you click on the triangle on the right, a drop-down will open with the breakdown of the amounts.',
      question11: 'How do I contact the owner?',
      answer11:
        "Once your reservation request has been made and accepted, the owner's contact details will appear at the bottom right. Click on the 'support' section and then select 'talk to the owner of your accommodation.' Additionally, you will also have access to frequently asked questions in case your inquiry is among them.",
      question12: 'What amount will I pay when I make my reservation request?',
      answer12:
        'You will not have to pay anything when making your reservation request. Once it is accepted by the owner, you must pay the stipulated amount within 48 hours.',
    },
  },
  relocatedHome: {
    choose: 'Now you can choose your accommodation',
    explore: 'Explore',
    prepare: 'Prepare your trip',
    checklist: 'This checklist will help you have everything ready for your trip',
    verify: 'Verify your identity',
    complete: 'Complete billing data',
    communicateGroup: 'Communicate with the group representative instantly',
  },
  onBoardingRelocated: {
    arriboIs: 'Arribo is absolutly yours!',
    prepared: 'prepared a previous profile with every aspect of your trip.',
    however:
      'However, please help us provide you with the best service by reviewing and confirming your information.',
    review: 'Review now',
    remind: 'Remind me later',
  },
  perks: {
    locationHint: {
      title: 'Enable your location',
      description: 'Get a better experience by discovering events near you.',
    },
    availableEvents: 'Available Events',
    noResults: 'No results found',
    results: 'results',
    detail: {
      title: 'Event Detail',
      loading: 'Loading event...',
      descriptionPlaceholder: 'This event does not have a description available.',
      location: 'Location',
      dateTime: 'Date and Time',
      similar: 'Similar Events',
      bookNow: 'Book now',
      whatsIncluded: 'What’s included',
      photos: 'Photos'
    },
    fromPrice: 'From',
    status: {
      available: 'Available',
      limited: 'Limited availability',
      soldout: 'Sold out',
    },
    searchPlaceholder: 'Search your next event here...',
    category: {
      essentials: 'Essentials',
      entertainment: 'Entertainment',
      seasonal: 'Seasonal events',
      food: 'Food & Drinks',
      city: 'City Tours',
    },
    filters: {
      today: 'Today',
      thisWeekend: 'This weekend',
      nextWeek: 'Next week',
    },
  },
  additionalCosts: {
    bookingPrice: {
      title: 'Landlord fee',
      description: 'Fee charged to landlord for property management',
    },
    deposit: {
      title: 'Deposit',
      description: 'Amount held as guarantee',
    },
    title: 'Additional costs',
    description: 'These are the amounts you will need to pay once your booking is accepted.',
    costsAndServices: 'Costs & services',
    gasFee: 'Gas',
    internetFee: 'Wi-Fi',
    waterFee: 'Water',
    cleaningFee: 'Cleaning fee',
    electricityFee: 'Electricity',
    included: 'Included',
    notIncluded: 'Not included',
  },  
  maintenance: {
    title: 'We’re making improvements',
    descriptionLine1: 'We are currently performing improvements and maintenance on the application.',
    descriptionLine2: 'Please try again in a few minutes.'
  },
  questionnaire: {
    title: 'Thanks for getting here!',
    submit: 'Submit',
    skip: 'Skip step',
    modal: {
      title: 'Could you tell us which one? (optional)',
      placeholder: 'Which referred you?',
      back: 'Back',
      submit: 'Submit'
    }
  }
};
